import type {SurveyAnswer, SurveyMediaValue} from "crqlar-react-common/dist/models/survey/surveySubmission.model";

/** The square every thumbnail is cut to, in pixels: sharp at the dialog's size on a 2x screen and on paper. */
const THUMBNAIL_PIXELS = 400;

const CLOUDINARY_IMAGE_UPLOAD = '/image/upload/';

/**
 * A square JPEG of an uploaded photo, cut by Cloudinary. The dialog, the print sheet, the PDF and the Word file all
 * draw this one image, so they show the same crop, and a HEIC photo, which most browsers cannot draw, arrives as a
 * JPEG. A link that is not a Cloudinary image is used as it is.
 */
export const surveyMediaThumbnailUrl = (media: SurveyMediaValue): string | undefined => {
    const url = media.mediaURI;
    if (!url) return undefined;

    const cut = url.indexOf(CLOUDINARY_IMAGE_UPLOAD);
    if (media.provider !== 'cloudinary' || cut < 0) return url;

    const head = url.slice(0, cut + CLOUDINARY_IMAGE_UPLOAD.length);
    const path = url.slice(cut + CLOUDINARY_IMAGE_UPLOAD.length).replace(/\.[a-z0-9]+$/i, '');

    return `${head}c_fill,w_${THUMBNAIL_PIXELS},h_${THUMBNAIL_PIXELS}/${path}.jpg`;
};

/**
 * The links of everything the guest uploaded or signed, uploads first: the text tier of the thumbnails, for the
 * spreadsheet exports, where a photo cannot sit in a cell.
 */
export const surveyAnswerMediaLinks = (answer: SurveyAnswer | undefined): string[] => [
    ...(answer?.mediaValues ?? []),
    ...(answer?.signatureValue ? [answer.signatureValue] : []),
].flatMap(media => (media.mediaURI ? [media.mediaURI] : []));
